import { render, staticRenderFns } from "./CytomineViewer.vue?vue&type=template&id=07cbf168&scoped=true"
import script from "./CytomineViewer.vue?vue&type=script&lang=js"
export * from "./CytomineViewer.vue?vue&type=script&lang=js"
import style0 from "./CytomineViewer.vue?vue&type=style&index=0&id=07cbf168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cbf168",
  null
  
)

export default component.exports